module.exports = __webpack_public_path__ + "static/media/36-3.351cce57.mp3";